function UploadMenuIconSchema(values) {
    let errors = {};

    if (!values.MenuID)
        errors.MenuID = 'ProductID is required';

    if (!values.Image)
        errors.Image = 'Image is required';

    return errors;
};

export default UploadMenuIconSchema;
